import { render, staticRenderFns } from "./RecomendacaoProdutos.vue?vue&type=template&id=7ec91bfb&scoped=true"
import script from "./RecomendacaoProdutos.vue?vue&type=script&lang=js"
export * from "./RecomendacaoProdutos.vue?vue&type=script&lang=js"
import style0 from "./RecomendacaoProdutos.vue?vue&type=style&index=0&id=7ec91bfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec91bfb",
  null
  
)

export default component.exports